import { Button } from '@/components/ui/button';
import { faFacebook, faInstagram, faLinkedinIn, faTiktok, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type SocialLinksProps = {
  profile: {
    facebookLink?: string | null;
    instagramLink?: string | null;
    youtubeLink?: string | null;
    twitterLink?: string | null;
    tiktokLink?: string | null;
    linkedinLink?: string | null;
  };
};

export function SocialLinks({ profile }: SocialLinksProps) {
  return (
    <div className="flex items-center justify-center space-x-4 md:justify-start md:px-6">
      {profile.facebookLink && (
        <a target="_blank" href={profile.facebookLink} aria-label="Facebook">
          <Button variant="secondary" type="button" className="size-14 hover:brightness-75 dark:hover:brightness-125">
            <FontAwesomeIcon width={24} height={24} icon={faFacebook} style={{ color: '#3b82f6' }} />
          </Button>
        </a>
      )}
      {profile.instagramLink && (
        <a target="_blank" href={profile.instagramLink} aria-label="Instagram">
          <Button variant="secondary" type="button" className="size-14 hover:brightness-75 dark:hover:brightness-125">
            <FontAwesomeIcon width={24} height={24} icon={faInstagram} style={{ color: '#ec4899' }} />
          </Button>
        </a>
      )}
      {profile.youtubeLink && (
        <a target="_blank" href={profile.youtubeLink} aria-label="YouTube">
          <Button variant="secondary" type="button" className="size-14 hover:brightness-75 dark:hover:brightness-125">
            <FontAwesomeIcon width={18} height={18} icon={faYoutube} style={{ color: '#ef4444' }} />
          </Button>
        </a>
      )}
      {profile.twitterLink && (
        <a target="_blank" href={profile.twitterLink} aria-label="Twitter">
          <Button variant="secondary" type="button" className="size-14 text-black hover:brightness-75 dark:hover:brightness-125">
            <FontAwesomeIcon width={24} height={24} icon={faXTwitter} />
          </Button>
        </a>
      )}
      {profile.tiktokLink && (
        <a target="_blank" href={profile.tiktokLink} aria-label="TikTok">
          <Button variant="secondary" type="button" className="size-14 hover:brightness-75 dark:hover:brightness-125">
            <FontAwesomeIcon width={24} height={24} icon={faTiktok} />
          </Button>
        </a>
      )}
      {profile.linkedinLink && (
        <a target="_blank" href={profile.linkedinLink} aria-label="LinkedIn">
          <Button variant="secondary" type="button" className="size-14 hover:brightness-75 dark:hover:brightness-125">
            <FontAwesomeIcon width={24} height={24} icon={faLinkedinIn} style={{ color: '#0e76a8' }} />
          </Button>
        </a>
      )}
    </div>
  );
}
